import km from 'keymirror'
import _ from 'underscore'

//TMR ==> ToManyRequests
export default _.extend({}, km({

  SESSION_SET_VALUE_START: null,
  SESSION_SET_VALUE_SUCCESS: null,
  SESSION_SET_VALUE_ERROR: null,
  SESSION_SET_VALUE_ERROR_EMPTY: null,
  SESSION_SET_VALUE_ERROR_TMR: null,

  SESSION_GIFT_SELECTED_SKU: null, //礼物派商品选择

}))
